<lib-segmented-control
  [(ngModel)]="value"
  name="v2"
  [list]="statusOptionsList"
  (ngModelChange)="onValueChange($event)"
></lib-segmented-control>